import {
  DeliveryPointReportSectionConfig,
  InstallationReportSectionConfig,
  InstallationReportSectionId,
} from './installation-reporting-mdu-section.types';

const plotDesign: InstallationReportSectionConfig = {
  id: 'PLOT_DESIGN',
  tabNameKey: 'installationReportV2.tabNames.PLOT_DESIGN',
  dates: 'plannedAndExecuted',
  plannedDateKey: 'installationReportV2.plotDesignTab.plannedPlotDesign',
  executedDateKey: 'installationReportV2.plotDesignTab.executedPlotDesign',
  hasComment: true,
  hasSigning: true,
  hasFiberData: false,
  imageChecklist: [],
  hasFileUpload: false,
  items: [],
};

const preInstallation: InstallationReportSectionConfig = {
  id: 'PRE_INSTALLATION',
  tabNameKey: 'installationReportV2.tabNames.PRE_INSTALLATION',
  dates: 'plannedAndExecuted',
  plannedDateKey:
    'installationReportV2.preinstallationTab.plannedPreinstallation',
  executedDateKey:
    'installationReportV2.preinstallationTab.executedPreinstallation',
  hasComment: true,
  hasSigning: false,
  hasFiberData: false,
  imageChecklist: [],
  hasFileUpload: false,
  items: [],
};

const plotExcavation: InstallationReportSectionConfig = {
  id: 'PLOT_EXCAVATION',
  tabNameKey: 'installationReportV2.tabNames.PLOT_EXCAVATION',
  dates: 'plannedAndExecuted',
  plannedDateKey:
    'installationReportV2.plotExcavationTab.plannedPlotExcavation',
  executedDateKey:
    'installationReportV2.plotExcavationTab.executedPlotExcavation',
  hasComment: true,
  hasSigning: false,
  hasFiberData: false,
  imageChecklist: [],
  hasFileUpload: false,
  items: [],
};

const ductConnection: InstallationReportSectionConfig = {
  id: 'DUCT_CONNECTING',
  tabNameKey: 'installationReportV2.tabNames.DUCT_CONNECTION',
  dates: 'executedOnly',
  executedDateKey: 'installationReportV2.ductConnectionTab.executedDate',
  hasComment: true,
  hasSigning: false,
  hasFiberData: false,
  imageChecklist: [],
  hasFileUpload: false,
  items: [],
};

const cableBlowing: InstallationReportSectionConfig = {
  id: 'CABLE_BLOWING',
  tabNameKey: 'installationReportV2.tabNames.CABLE_BLOWING',
  dates: 'plannedAndExecuted',
  plannedDateKey: 'installationReportV2.cableBlowingTab.plannedCableBlowing',
  executedDateKey: 'installationReportV2.cableBlowingTab.executedCableBlowing',
  hasComment: true,
  hasSigning: false,
  hasFiberData: false,
  imageChecklist: [],
  hasFileUpload: false,
  items: [],
};

const splicingMeasuring: InstallationReportSectionConfig = {
  id: 'SPLICING_MEASURING',
  tabNameKey: 'installationReportV2.tabNames.SPLICING_MEASURING',
  dates: 'plannedAndExecuted',
  plannedDateKey:
    'installationReportV2.splicingAndMeasuringTab.plannedMeasuring',
  executedDateKey:
    'installationReportV2.splicingAndMeasuringTab.executedMeasuring',
  hasComment: true,
  hasSigning: false,
  hasFiberData: true,
  imageChecklist: [],
  hasFileUpload: false,
  items: [],
};

const commissioning: InstallationReportSectionConfig = {
  id: 'COMMISSION',
  tabNameKey: 'installationReportV2.tabNames.COMMISSIONING',
  dates: 'plannedAndExecuted',
  plannedDateKey: 'installationReportV2.commissioningTab.plannedCommissioning',
  executedDateKey:
    'installationReportV2.commissioningTab.executedCommissioning',
  hasComment: true,
  hasSigning: false,
  hasFiberData: false,
  imageChecklist: [
    {
      field: 'hasOdfPortImage',
      labelKey: 'installationReportV2.imageChecklist.listItems.hasOdfPortImage',
    },
    {
      field: 'hasSwitchPortImage',
      labelKey:
        'installationReportV2.imageChecklist.listItems.hasSwitchPortImage',
    },
    {
      field: 'hasNodeImage',
      labelKey: 'installationReportV2.imageChecklist.listItems.hasNodeImage',
    },
  ],
  hasFileUpload: true,
  items: [],
};

export const BUILDING_REPORT_SECTIONS: InstallationReportSectionConfig[] = [
  plotDesign,
  preInstallation,
  plotExcavation,
  ductConnection,
  cableBlowing,
  splicingMeasuring,
  commissioning,
];

export const DELIVERY_POINT_REPORT_SECTIONS: DeliveryPointReportSectionConfig[] =
  BUILDING_REPORT_SECTIONS.filter(
    (section): section is DeliveryPointReportSectionConfig =>
      section.id === 'PRE_INSTALLATION' ||
      section.id === 'SPLICING_MEASURING' ||
      section.id === 'COMMISSION',
  );

export const BUILDING_REPORT_SECTION_BY_ID: Record<
  InstallationReportSectionId,
  InstallationReportSectionConfig
> = Object.fromEntries(
  BUILDING_REPORT_SECTIONS.map((section) => [section.id, section]),
) as Record<InstallationReportSectionId, InstallationReportSectionConfig>;
